import {
  Modal,
  Box,
  Tab,
  Tabs,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import closeIcon from "../../assets/icons/closeIcon.svg";
import { useEffect, useState } from "react";
import Spinner from "../../layouts/spinner/Spinner";
import "./FbKeysConfirmationModal.css";



interface Column {
  id: 'SecretName' | 'NewValue' | 'OldValue';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}



const allColumns: readonly Column[] = [
  { id: "SecretName", label: "Key Name", minWidth: 170 },
  { id: "OldValue", label: "Old Value", minWidth: 100 },
  { id: "NewValue", label: "Value", minWidth: 100 },
];

const columnsWithoutOldValue: readonly Column[] = [
  { id: "SecretName", label: "Key Name", minWidth: 350 },
  { id: "NewValue", label: "Value", minWidth: 350 },
];


interface ConfirmChangesModalProps {
  openConfirmModal: boolean;
  loading?: boolean;
  title?: string;
  data?: any;
  handleCloseModal: () => void;
  handleSubmit: (e: any) => void;
}

const ConfirmChangesModal = ({
  openConfirmModal = false,
  handleCloseModal,
  handleSubmit,
  loading = false,
  title = "Confirm Changes",
  data = [],
}: ConfirmChangesModalProps) => {

  const [rows, setRows] = useState<any>([]);
  useEffect(() => {
    setRows(data.filter((e:any)=>e.ActionType === "Insert"));
  }, [data]);

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if(newValue===0){
      setRows(data.filter((e:any)=>e.ActionType === "Insert"));
    }
    else if(newValue===1){
      setRows(data.filter((e:any)=>e.ActionType === "Update"));
    }
    else if(newValue===2){
      setRows(data.filter((e:any)=>e.ActionType === "Delete"));
    }
    setTabIndex(newValue);
  };

  const handleConfirm = (event: any) => {
    event.preventDefault();
    handleSubmit("addItemFormInput");
    setTabIndex(0);
  };
  const CloseModal = () => {
    setTabIndex(0);
    handleCloseModal();
  };
  const columns = tabIndex === 1 ? allColumns : columnsWithoutOldValue;

  return (
    <>
      <Modal
        open={openConfirmModal}
        onClose={CloseModal}
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box">
          <div className="modal-1-header">
            <div className="modal-1-title">{title}</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                CloseModal();
              }}
            >
              <img src={closeIcon} className="icon-md" alt="" />
            </div>
          </div>
          <form onSubmit={handleConfirm}>
            <div className="model-1-form-body grid-column-full">
          
              <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                aria-label="modal tabs"
                className="custom-tabs"
              >
                <Tab label="New Keys" />
                <Tab label="Update Keys" />
                <Tab label="Delete Keys" />
              </Tabs>

              <TableContainer sx={{ maxHeight: 340 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth, overflowX: 'hidden',fontWeight:"bold" }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .map((row:any) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                          >
                            {columns.map((column) => {
                           
                              const value = (column.id==="SecretName")?row[column.id].toUpperCase().replace(/[_ ]/g, "-"):row[column.id];
                              return (
                                <TableCell key={column.id} align={column.align} title={value}>
                                  { value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="model-1-form-actions center-div">
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                onClick={() => {
                  CloseModal();
                }}
              >
                <div>Cancel</div>
              </button>
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                type="submit"
                disabled={loading}
              >
                <div>{loading ? <Spinner size="1rem" /> : <>Done</>} </div>
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default ConfirmChangesModal;
